<template>
  <div class="modalbox modalStep" id="waypointModal">
    <!-- eslint-disable max-len-->
    <div class="is-flex bigmodal">
      <router-link :to="'/formation-apprenant/' +
        $route.params.idTraining +
        '/' +
        $route.params.idStudent +
        '/' +
        $route.params.idStudentTraining +
        '/waypoint'
        " class="btn-previous"> <img :src="require('@/assets/img/arrows/previous.svg')" /></router-link>
      <router-link v-if="
        currentUser.role === 'formateur' ||
        currentUser.role === 'coordinateur'
      " class="ml-auto mr-2" :to="'/formations/' + $route.params.idTraining + '/suivi/validationSteps'
        ">
        <b-button type="is-outlined" rounded size="is-small">Formation</b-button>
      </router-link>
      <router-link class="mr-2" :to="'/formation-apprenant/' +
        $route.params.idTraining +
        '/' +
        $route.params.idStudent +
        '/' +
        $route.params.idStudentTraining +
        '/parcours'
        ">
        <b-button type="is-outlined" rounded size="is-small">Parcours</b-button>
      </router-link>
      <router-link :to="'/formation-apprenant/' +
        $route.params.idTraining +
        '/' +
        $route.params.idStudent +
        '/' +
        $route.params.idStudentTraining +
        '/waypoint'
        ">
        <b-button type="is-outlined" rounded size="is-small">Livret de suivi</b-button></router-link>
    </div>
    <b-loading :is-full-page="isFullPage" v-model="isLoading"> </b-loading>
    <section class="w-100 container">
      <!-- Indicateur de statut de connexion -->
      <b-message v-if="!isOnline" type="is-warning" has-icon class="mb-4">
        <strong>Mode hors ligne</strong>
        <p>Vous êtes actuellement hors ligne. Vos modifications seront sauvegardées localement et synchronisées automatiquement dès que la connexion sera rétablie.</p>
        <p v-if="pendingSyncCount > 0">
          <strong>{{ pendingSyncCount }}</strong> {{ pendingSyncCount > 1 ? 'modifications' : 'modification' }} en attente de synchronisation.
        </p>
      </b-message>
      <b-message v-else-if="pendingSyncCount > 0 && isSyncing" type="is-info" has-icon class="mb-4">
        <strong>Synchronisation en cours...</strong>
        <p>Synchronisation des modifications enregistrées localement.</p>
      </b-message>
      <b-message v-else-if="pendingSyncCount === 0 && lastSyncSuccess" type="is-success" has-icon class="mb-4">
        <strong>Synchronisation réussie !</strong>
        <p>Toutes vos modifications ont été synchronisées avec succès.</p>
      </b-message>
      <div class="title-paragraph">
        {{ waypoint.name }}
      </div>
      <div class="studentName" v-if="currentUser.role !== 'apprenant' && booklet_validation">
        <span v-if="this.booklet_validation.data">{{
          this.booklet_validation.data[0].name
          }}</span>
      </div>
      <div class="has-text-centered mb-2">
        <b-tag type="is-success" v-if="this.validated === 'Effectué'">{{
          this.validated
          }}</b-tag>
        <b-tag type="is-primary" v-else-if="this.validated === 'En cours'">{{
          this.validated
          }}</b-tag>
        <b-tag type="is-danger is-light" v-else-if="this.validated === 'Litige'">{{ this.validated }}</b-tag>
        <b-tag type="is-outlined" v-else-if="this.validated === 'A faire'">{{
          this.validated
          }}</b-tag>
        <b-tag type="is-info" v-else>{{ this.validated }}</b-tag>
      </div>
      <div class="justify-content-center is-flex align-items-center">
        <span v-if="waypoint.due_datetime">
          A remplir entre le {{ waypoint.start_date | day }} et le {{ waypoint.due_datetime | day }}
        </span>
        <span v-else>
          A remplir à partir du {{ waypoint.start_date | day }}
        </span>
      </div>
      <div v-html="waypoint.helper" class="has-text-centered mb-4 mt-3" v-if="waypoint.helper"></div>
      <div v-if="json_form != null">
        <Survey :survey="survey" />
      </div>
      <div v-if="waypoint.resources" class="mt-4">
        <div v-if="waypoint.resources.length">
          <div v-for="resource in waypoint.resources" :key="resource.id">
            <ResourceCardSimple :resource="resource" :action="'read'"></ResourceCardSimple>
          </div>
        </div>
      </div>
      <div>
        <div v-if="this.json_form == null">
          <div class="ck-editor-block mb-0 pb-0" v-if="!idPatch">
            <ckeditor v-model="formWaypoint.content" :editor="editor" :config="editorConfig" class="mb-5"
              :ref="'revisionContent'"></ckeditor>
          </div>
          <div class="ck-editor-block mb-0 pb-0" v-else>
            <ckeditor v-model="formWaypoint.entry" :editor="editor" :config="editorConfig" class="mb-5"
              :ref="'revisionContent'"></ckeditor>
          </div>
        </div>
        <div v-if="booklet_validation.data">
          <div class="cardValidation" v-if="booklet_validation.data[0].data[0].validations.length">
            <div class="mb-3" v-if="booklet_validation.data[0].data[0].validations.length">
              <b class="title-paragraph" style="font-size: 1.2rem">Validations attendues</b>
            </div>
            <div class="b-steps is-small w-100">
              <nav class="steps is-rounded">
                <ul class="step-items" v-if="booklet_validation.data">
                  <li class="step-item is-previous" v-for="validation in booklet_validation.data[0].data[0]
                    .validations" :key="validation.id">
                    <a class="step-link">
                      <div class="step-marker">
                        <img v-if="validation.status_label == 'Valide'" :src="require(`@/assets/img/steps/status3.svg`)"
                          alt="" class="img_status mx-auto" />

                        <img v-else-if="validation.status_label == 'A faire'"
                          :src="require(`@/assets/img/steps/status6.svg`)" alt="" class="img_status mx-auto" />
                        <img v-else :src="require(`@/assets/img/steps/status5.svg`)" alt=""
                          class="img_status mx-auto" />
                      </div>
                      <div class="step-details">
                        <span class="step-title"> {{ validation.name }}</span>
                      </div>
                      <div class="mt-2">
                        <b-tag v-if="validation.status_label == 'Valide'" type="is-success">
                          {{ validation.status_label }}</b-tag>
                        <b-tag v-else-if="validation.status_label == 'A faire'" type="is-secondary is-outlined">
                          {{ validation.status_label }}</b-tag>
                        <b-tag v-else type="is-danger">
                          {{ validation.status_label }}</b-tag>

                        <div class="mt-2 datetime" v-if="validation.validation_datetime">
                          {{ validation.validation_datetime | day }}
                        </div>
                        <span class="step-name" v-if="validation.validator_name">
                          {{ validation.validator_name }}</span>
                        <div class="mt-2" v-if="!isValidationAllowed(validation) && validation.status_label !== 'Valide'">
                          <small class="has-text-warning">⚠️ Validation précédente attendue</small>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div>
      <div class="is-flex is-flex-wrap-wrap activityBtns align-items-center" style="z-index: 2000">
        <div class="w-100 is-flex">
          <div class="mx-auto">
            <div class="is-flex">
              <div v-if="
                waypoint.editable &&
                new Date(waypoint.start_date) < new Date()
              ">

                <span v-if="waypoint.editable.includes(currentUser.role)">
                  <span v-if="json_form != null">
                    <b-button v-if="
                      !this.validation ||
                      this.validation.status_label === 'A faire' ||
                      this.validation.status_label === 'En retard'
                    " @click="survey.completeLastPage()" class="btn-action w-auto mr-1" type="is-primary is-rounded"
                      rounded>enregistrer</b-button>
                  </span>
                  <span v-else>
                    <b-button v-if="
                      !this.validation ||
                      this.validation.status_label === 'A faire' ||
                      this.validation.status_label === 'En retard'
                    " @click="patchBookletPart(false)" class="btn-action w-auto mr-1" type="is-primary is-rounded"
                      rounded>enregistrer</b-button>
                  </span>
                </span>
                <span v-if="this.validation">
                  <span v-if="
                    !this.validation.status_label ||
                    this.validation.status_label === 'A faire' ||
                    this.validation.status_label === 'En retard'">
                    <b-button v-if="json_form != null && isSurveyValid && canValidate" class="btn-action w-auto" type="is-success is-rounded" rounded
                      :disabled="!idPatch" @click="validateBookletPart(1)">valider</b-button>
                    <b-button v-else-if="json_form == null && canValidate" @click="validateBookletPart(1)" class="btn-action w-auto"
                      type="is-success is-rounded" rounded>valider</b-button>
                    <span v-else-if="!canValidate" class="has-text-danger has-text-centered ml-2">
                      <b>Une validation précédente doit être effectuée avant que vous puissiez valider cette fiche</b>
                    </span>
                  </span>
                </span>
              </div>

              <div v-if="
                this.validation && this.validation.status_label !== 'A faire'
              " class="mx-auto is-flex align-items-center">
                <span v-if="this.validation.status_label === 'Valide'"
                  class="has-text-success has-text-centered"><b>Vous avez validé cette fiche</b>
                  <span v-if="json_form != null"> <b-button v-if="this.validated !== 'Effectué'"
                      @click="survey.completeLastPage()" class="btn-action w-auto mr-1"
                      type="is-primary is-rounded is-outlined is-small" rounded>enregistrer
                    </b-button></span> <span v-else><b-button v-if="this.validated !== 'Effectué'"
                      @click="patchBookletPart(false)" class="btn-action w-auto mr-1"
                      type="is-primary is-rounded is-outlined is-small" rounded>enregistrer
                    </b-button></span>
                </span>
                <span v-else-if="
                  this.validation.status_label === 'Non valide' &&
                  this.validation
                " class="has-text-danger has-text-centered"><b>Vous avez refusé de valider cette fiche</b>
                </span>
                <b-button v-if="
                  this.validation &&
                  this.validation.status_label == 'Valide' &&
                  waypoint.editable.includes('currentUser.role')
                " @click="patchBookletPart(false)" class="btn-action w-auto mr-1"
                  type="is-primary is-rounded is-outlined is-small" rounded>enregistrer les modifications
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="help-btn">
          <AppHelpMessage v-if="waypoint.type === 0" title="Rédigez et enregistrez votre point en entreprise" message="La liste des expériences en entreprise remonte automatiquement.
             Si rien n'a été enregistré dans inSitu, vous pouvez revenir dans l'onglet 'Parcours'
              et enregistrer des expériences. Vous pouvez aussi utiliser les champs
               commentaires pour ajouter des éléments. <b> Une fois validé, vous pourrez corriger
                  une faute, ajouter un commentaire mais vous ne pourrez plus toucher
                   aux actviités vécues." textBtn="Besoin d'aide ?" />
          <AppHelpMessage v-if="waypoint.type === 1" title="Rédigez et enregistrez votre point en centre de formation"
            message="La liste des modules remonte automatiquement.
             Si un module a été ajouté en cours de formation et n'ets pas listé ici,
              vous pouvez utiliser les champs commentaires pour préciser ce qui a été vu." textBtn="Besoin d'aide ?" />
        </div>
      </div>
    </div>

    <div class="container contentSequence pb-5 mb-5"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
import AppHelpMessage from '@/components/AppHelpMessage.vue';
import booklet from '@/components/Waypoints/booklet.json';
import _ from 'lodash';
import ResourceCardSimple from '@/components/Resources/ResourceCardSimple.vue';

// SurveyJs
import { Model } from 'survey-core';
import '@/assets/css/survey-core.defaultV2.css';
import { Survey } from 'survey-vue-ui';
import 'survey-core/i18n/french';

export default ({
  filters: {
    day(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
  components: {
    AppHelpMessage,
    ckeditor: CKEditor.component,
    ResourceCardSimple,
    Survey,
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    canValidate() {
      // Les coordinateurs et directeurs peuvent toujours valider
      if (this.currentUser.role === 'coordinateur' || this.isDirector) {
        return true;
      }

      // Vérifier si la validation courante est bloquée par une validation précédente
      if (!this.validation || !this.booklet_validation.data) {
        return true;
      }

      return this.isValidationAllowed(this.validation);
    },
    isSurveyValid() {
      // Vérifier si tous les champs obligatoires du Survey sont remplis
      // Utiliser surveyDataVersion pour forcer le recalcul quand les données changent
      // eslint-disable-next-line no-unused-vars
      const version = this.surveyDataVersion;
      
      if (!this.json_form || !this.survey) {
        return true; // Pas de Survey, pas de validation nécessaire
      }

      const allQuestions = this.survey.getAllQuestions();
      for (const question of allQuestions) {
        if (question.isRequired) {
          const value = this.survey.getValue(question.name);
          // Vérifier si la valeur est vide, null, undefined ou un tableau/objet vide
          const isEmpty = value === null || 
                         value === undefined || 
                         value === '' || 
                         (Array.isArray(value) && value.length === 0) ||
                         (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);
          
          if (isEmpty) {
            return false; // Un champ obligatoire est vide
          }
        }
      }
      
      return true; // Tous les champs obligatoires sont remplis
    },
  },
  data() {
    return {
      isLoading: false,
      isFullPage: false,
      schoolSubjectsTraining: [],
      schoolSubjects: [],
      schoolSubjectsSelected: [],
      waypoint: [],
      arrayReports: [],
      student_activities_report: [],
      student_revisions_report: [],
      free_situations_report: [],
      formWaypoint: {
        id: '',
        title: '',
        comment: '',
        tutor_comment: '',
        teacher_comment: '',
        start_date: '',
        end_date: '',
        reports: [],
        validated: false,
        entry: '',
      },
      checkboxCustom: [],
      activities: [],
      isOpenActivities: false,
      isOpenRevision: false,
      isOpenFree: false,
      editor: ClassicEditor,
      editorDisabled: true,
      editorConfig: {
        language: 'fr',
        toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'link', '|', 'undo',
          'redo'],
        alignment: {
          options: ['left', 'right'],
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Styles de texte', class: 'ck-heading_paragraph' },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Titre 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Titre 2',
              class: 'ck-heading_heading2',
            },
            {
              model: 'mark',
              view: 'mark',
              title: 'surligné',
              class: 'ck-mark',
            },
          ],
        },
        table: {
          contentToolbar: null,
        },
      },
      bookletJson: booklet,
      patchPart: false,
      idPatch: null,
      booklet_validation: [],
      validation: [],
      isDirector: false,
      validated: '',
      survey: new Model(),
      json_form: null,
      surveyDataVersion: 0, // Pour forcer le recalcul de isSurveyValid
      // Gestion offline
      isOnline: navigator.onLine,
      pendingSyncCount: 0,
      isSyncing: false,
      lastSyncSuccess: false,
      syncCheckInterval: null,
      surveySaveTimeout: null,
      surveyIdleSaveTimeout: null,
      lastSurveyData: null,
    };
  },
  methods: {
    startLoading() {
      this.isLoading = true;
    },
    endLoading() {
      this.isLoading = false;
    },
    initDirector() {
      this.$http
        .get(`/trainings/${this.$route.params.idTraining}/?query={directors}&format=json`)
        .then((response) => {
          const director = response.data.directors;
          if (director.includes(this.currentUser.id)) {
            this.isDirector = true;
          }
          const part = this.waypoint;
          if (!part.editable.includes(this.currentUser.role)) {
            this.$router.push({
              name: 'BookletPartRead',
              params: {
                idTraining: this.$route.params.idTraining,
                idStudent: this.$route.params.idStudent,
                idStudentTraining: this.$route.params.idStudentTraining,
                idPart: this.$route.params.idPart,
              },
            });
          }
        });
    },
    initBookletPart() {
      this.startLoading();
      const urlWs = `/get_booklet_part/${this.$route.params.idPart}?student_training=${this.$route.params.idStudentTraining}&format=json`;
      this.$http
        .get(`${urlWs}`)
        .then((response) => {
          this.waypoint = response.data;
          this.initDirector();
          this.formWaypoint = this.waypoint;
          const entry = _.findIndex(this.waypoint.entries, ['student_training', Number(this.$route.params.idStudentTraining)]);
          if (entry !== -1) {
            this.formWaypoint.entry = this.waypoint.entries[entry].content;
            this.idPatch = this.waypoint.entries[entry].id;
          }
          this.endLoading();

          // SurveyJs
          this.json_form = response.data.form_structure;
          window.console.log(JSON.parse(this.json_form));
          if (this.json_form !== null) {
            this.survey = new Model(JSON.parse(this.json_form));
            this.survey.locale = 'fr';
            this.survey.mode = 'edit';

            // Sauvegarder automatiquement à chaque changement de valeur (dès que le focus change)
            this.survey.onValueChanged.add((sender) => {
              // Incrémenter la version pour forcer le recalcul de isSurveyValid
              this.surveyDataVersion++;
              
              // Utiliser un debounce pour éviter trop de sauvegardes
              if (this.surveySaveTimeout) {
                clearTimeout(this.surveySaveTimeout);
              }
              this.surveySaveTimeout = setTimeout(() => {
                this.saveSurveyDataAuto(sender.data);
                this.lastSurveyData = sender.data;
                // Si on est en ligne, essayer de synchroniser automatiquement (sans bloquer l'interface)
                if (this.isOnline && !this.isSyncing) {
                  this.autoSyncSurveyData(sender.data);
                }
                // Démarrer le timer pour sauvegarder après 5 secondes d'inactivité sur le champ
                this.startIdleSaveTimer(sender.data);
              }, 300); // Sauvegarder 300ms après le dernier changement
            });

            // Détecter quand un champ reçoit le focus pour démarrer le timer d'inactivité
            // Utiliser un délai après le rendu pour permettre au DOM de se mettre à jour
            this.survey.onAfterRenderQuestion.add((sender, options) => {
              this.$nextTick(() => {
                // Attacher un écouteur de focus sur les champs du formulaire
                const questionElement = options.htmlElement;
                if (questionElement) {
                  const inputElements = questionElement.querySelectorAll('input, textarea, select');
                  inputElements.forEach((input) => {
                    // Supprimer l'ancien écouteur s'il existe
                    input.removeEventListener('focus', this.handleFieldFocus);
                    // Ajouter le nouvel écouteur
                    input.addEventListener('focus', this.handleFieldFocus);
                  });
                }
              });
            });

            this.survey.onComplete.add((sender) => {
              window.console.log(JSON.stringify(sender.data, null, 3));
              this.formWaypoint.entry = JSON.stringify(sender.data);
              this.formWaypoint.content = JSON.stringify(sender.data);
              
              // Gestion hors ligne : sauvegarder en local si nécessaire
              if (!this.isOnline) {
                this.saveSurveyToLocalQueue(sender.data);
                this.$buefy.toast.open({
                  message: 'Formulaire sauvegardé localement (hors ligne)',
                  type: 'is-warning',
                  duration: 4000,
                });
              } else {
                // Mode en ligne : enregistrement normal
                this.patchBookletPart(false);
              }
            });
            
            // Charger les données sauvegardées localement si elles existent (après initialisation)
            this.$nextTick(() => {
              this.loadSavedSurveyData();
            });
            // Fin SurveyJs
          }
        });
    },
    initPart() {
      this.startLoading();
      this.$http
        .get(`/get_training_booklet_validations/${this.$route.params.idTraining}?step=${this.$route.params.idPart}&student_training=${this.$route.params.idStudentTraining}`)
        .then((response) => {
          this.booklet_validation = response.data;
          this.validated = this.booklet_validation.data[0].data[0].user_status_label;
          if (this.isDirector) {
            const indexValidation = _.findKey(this.booklet_validation.data[0].data[0].validations,
              ['role', 'directeur']);
            this.validation = this.booklet_validation.data[0].data[0].validations[indexValidation];
          } else {
            const indexValidation = _.findKey(this.booklet_validation.data[0].data[0].validations,
              ['role', this.currentUser.role]);
            this.validation = this.booklet_validation.data[0].data[0].validations[indexValidation];
          }
          this.endLoading();
        });
    },
    postBookletPart(statusValidation) {
      if (this.isOnline) {
        // Mode en ligne : envoi direct
        this.$http
          .post('booklet_parts_entries/', {
            simple_booklet_part: this.$route.params.idPart,
            student_training: this.$route.params.idStudentTraining,
            content: this.formWaypoint.content,
          }).then((response) => {
            // Nettoyer la sauvegarde automatique après synchronisation réussie
            const autoSaveKey = this.getSurveyAutoSaveKey();
            localStorage.removeItem(autoSaveKey);
            
            this.$buefy.toast.open({ message: 'Fiche enregistrée', type: 'is-success' });
            if (statusValidation) {
              this.postValidation(statusValidation, response.data.id);
            } else {
              this.initBookletPart();
            }
          }).catch((error) => {
            // Si erreur réseau, sauvegarder en local
            if (!navigator.onLine || error.code === 'NETWORK_ERROR') {
              this.saveBookletPartToLocalQueue(true, statusValidation);
              this.$buefy.toast.open({
                message: 'Enregistré localement (hors ligne)',
                type: 'is-warning',
                duration: 4000,
              });
            } else {
              window.console.log(error);
              this.errored = true;
              this.$buefy.dialog.alert({
                title: 'Mince...',
                message: 'L\'activité n\'a pas pu être enregistrée.',
                type: 'is-info',
                hasIcon: true,
                icon: 'times-circle',
                ariaRole: 'alertdialog',
                ariaModal: true,
                confirmText: 'Ok',
              });
            }
          });
      } else {
        // Mode hors ligne : sauvegarde locale
        this.saveBookletPartToLocalQueue(true, statusValidation);
        this.$buefy.toast.open({
          message: 'Fiche enregistrée localement (hors ligne)',
          type: 'is-warning',
          duration: 4000,
        });
      }
    },
    patchBookletPart(statusValidation) {
      if (this.idPatch) {
        if (this.isOnline) {
          // Mode en ligne : envoi direct
          this.$http
            .patch(`booklet_parts_entries/${this.idPatch}/`, {
              content: this.formWaypoint.entry,
            }).then(() => {
              // Nettoyer la sauvegarde automatique après synchronisation réussie
              const autoSaveKey = this.getSurveyAutoSaveKey();
              localStorage.removeItem(autoSaveKey);
              
              this.$buefy.toast.open({ message: 'Fiche enregistrée', type: 'is-success' });
              if (statusValidation) {
                this.postValidation(statusValidation);
              } else {
                this.initBookletPart();
              }
            }).catch((error) => {
              // Si erreur réseau, sauvegarder en local
              if (!navigator.onLine || error.code === 'NETWORK_ERROR') {
                this.saveBookletPartToLocalQueue(false, statusValidation);
                this.$buefy.toast.open({
                  message: 'Enregistré localement (hors ligne)',
                  type: 'is-warning',
                  duration: 4000,
                });
              } else {
                window.console.log(error);
                this.errored = true;
                this.$buefy.dialog.alert({
                  title: 'Mince...',
                  message: 'L\'activité n\'a pas pu être enregistrée.',
                  type: 'is-info',
                  hasIcon: true,
                  icon: 'times-circle',
                  ariaRole: 'alertdialog',
                  ariaModal: true,
                  confirmText: 'Ok',
                });
              }
            });
        } else {
          // Mode hors ligne : sauvegarde locale
          this.saveBookletPartToLocalQueue(false, statusValidation);
          this.$buefy.toast.open({
            message: 'Fiche enregistrée localement (hors ligne)',
            type: 'is-warning',
            duration: 4000,
          });
        }
      } else {
        if (this.isOnline) {
          this.postBookletPart(statusValidation);
        } else {
          // Mode hors ligne : sauvegarde locale
          this.saveBookletPartToLocalQueue(true, statusValidation);
          this.$buefy.toast.open({
            message: 'Fiche enregistrée localement (hors ligne)',
            type: 'is-warning',
            duration: 4000,
          });
        }
      }
    },
    validateBookletPart(statusValidation) {
      // Vérifier les champs obligatoires du formulaire Survey si présent
      if (this.json_form != null && this.survey) {
        // Valider le formulaire Survey
        const validationResult = this.survey.validate();
        
        // Récupérer toutes les questions obligatoires manquantes
        const missingFields = [];
        
        // Vérifier les erreurs de validation
        if (validationResult && Object.keys(validationResult).length > 0) {
          Object.keys(validationResult).forEach((questionName) => {
            const question = this.survey.getQuestionByName(questionName);
            if (question && question.isRequired) {
              // Utiliser le titre de la question ou le nom si pas de titre
              const fieldTitle = question.title || questionName;
              if (!missingFields.includes(fieldTitle)) {
                missingFields.push(fieldTitle);
              }
            }
          });
        }
        
        // Vérifier aussi toutes les questions obligatoires qui pourraient être vides
        // (certaines questions peuvent être obligatoires mais ne pas déclencher d'erreur de validation)
        const allQuestions = this.survey.getAllQuestions();
        allQuestions.forEach((question) => {
          if (question.isRequired) {
            const value = this.survey.getValue(question.name);
            // Vérifier si la valeur est vide, null, undefined ou un tableau/objet vide
            const isEmpty = value === null || 
                           value === undefined || 
                           value === '' || 
                           (Array.isArray(value) && value.length === 0) ||
                           (typeof value === 'object' && Object.keys(value).length === 0);
            
            if (isEmpty) {
              const fieldTitle = question.title || question.name;
              if (!missingFields.includes(fieldTitle)) {
                missingFields.push(fieldTitle);
              }
            }
          }
        });
        
        // Si des champs obligatoires sont manquants, afficher une alerte
        if (missingFields.length > 0) {
          let message = 'Impossible de valider la fiche. ';
          message += 'Les champs obligatoires suivants doivent être remplis :\n\n';
          message += missingFields.map(field => `• ${field}`).join('\n');
          
          this.$buefy.dialog.alert({
            title: 'Champs obligatoires manquants',
            message: message,
            type: 'is-danger',
            hasIcon: true,
            icon: 'exclamation-triangle',
            ariaRole: 'alertdialog',
            ariaModal: true,
            confirmText: 'Ok',
          });
          
          // Ne pas procéder à la validation
          return;
        }
      }

      // Si pas d'erreurs, afficher la boîte de dialogue de confirmation
      this.$buefy.dialog.confirm({
        title: 'Souhaitez-vous valider cette fiche ?',
        message: 'Vous êtes sur le point de valider cette fiche, vous confirmez que vous l\'avez bien relue. Toute modification sera ensuite impossible.',
        confirmText: 'Valider',
        cancelText: 'Relire',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          if (this.idPatch) {
            if (this.json_form != null) {
              this.survey.completeLastPage();
              this.postValidation(statusValidation);
            } else {
              window.console.log('patch old form');
              this.$http
                .patch(`booklet_parts_entries/${this.idPatch}/`, {
                  content: this.formWaypoint.entry,
                }).then(() => {
                  this.$buefy.toast.open({ message: 'Fiche enregistrée', type: 'is-success' });
                  this.postValidation(statusValidation);
                }).catch((error) => {
                  window.console.log(error);
                  this.errored = true;
                  this.$buefy.dialog.alert({
                    title: 'Mince...',
                    message: 'L\'activité n\'a pas pu être enregistrée.',
                    type: 'is-info',
                    hasIcon: true,
                    icon: 'times-circle',
                    ariaRole: 'alertdialog',
                    ariaModal: true,
                    confirmText: 'Ok',
                  });
                });
            }
          } else {
            this.postBookletPart(statusValidation);
          }
          this.goPreviousPage();
        },
      });
    },
    postValidation(statusValidation, identry) {
      let roleValidator = '';
      if (this.isDirector) {
        roleValidator = 'directeur';
      } else {
        roleValidator = this.currentUser.role;
      }
      if (!this.idPatch) {
        this.idPatch = identry;
      }

      const validationData = {
        role: roleValidator,
        student_training: Number(this.$route.params.idStudentTraining),
        simple_booklet_part_validation: this.validation.id,
        status: statusValidation,
      };

      if (this.isOnline) {
        // Mode en ligne : envoi direct
        this.$http
          .post('/validations/validation/', validationData)
          .then(() => {
            this.$buefy.toast.open({
              message: 'La validation a bien été enregistrée',
              type: 'is-success',
            });
            this.goPreviousPage();
          })
          .catch((error) => {
            // Si erreur réseau, sauvegarder en local
            if (!navigator.onLine || error.code === 'NETWORK_ERROR') {
              this.saveValidationToLocalQueue(validationData);
              this.$buefy.toast.open({
                message: 'Validation enregistrée localement (hors ligne)',
                type: 'is-warning',
                duration: 4000,
              });
            } else {
              window.console.log(error);
              this.issue = true;
              this.$buefy.dialog.alert({
                title: 'Mince...',
                message: 'Votre validation n\'a pas pu être enregistrée',
                type: 'is-info',
                hasIcon: true,
                icon: 'times-circle',
                ariaRole: 'alertdialog',
                ariaModal: true,
                confirmText: 'Ok',
              });
            }
          });
      } else {
        // Mode hors ligne : sauvegarde locale
        this.saveValidationToLocalQueue(validationData);
        this.$buefy.toast.open({
          message: 'Validation enregistrée localement (hors ligne)',
          type: 'is-warning',
          duration: 4000,
        });
      }
    },
    saveValidationToLocalQueue(validationData) {
      try {
        const storageKey = `booklet_validation_sync_queue_${this.$route.params.idPart}_${this.$route.params.idStudentTraining}`;
        let queue = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const queueItem = {
          id: Date.now() + Math.random(),
          action: 'postValidation',
          data: validationData,
          timestamp: new Date().toISOString(),
        };
        queue.push(queueItem);
        localStorage.setItem(storageKey, JSON.stringify(queue));
        this.loadPendingSyncCount(); // Mettre à jour le compteur
        console.log('Validation sauvegardée localement:', queueItem);
      } catch (error) {
        console.error('Erreur lors de la sauvegarde locale de la validation:', error);
      }
    },
    goPreviousPage() {
      this.$router.go(-1);
    },

    gotoActivity(id, sequenceId) {
      this.$router.push({
        name: 'StudentActivity',
        params: {
          idTraining: this.$route.params.idTraining,
          idStudentTraining: this.$route.params.idStudentTraining,
          idActivity: id,
          idSequence: sequenceId,
          from: this.$route.name,
          idStudent: this.$route.params.idStudent,
          idWaypoint: this.$route.params.idWaypoint,
        },
      });
    },
    // Gestion de la queue locale pour le mode offline
    getStorageKey() {
      return `booklet_part_sync_queue_${this.$route.params.idPart}_${this.$route.params.idStudentTraining}`;
    },
    getSurveyAutoSaveKey() {
      return `booklet_part_survey_autosave_${this.$route.params.idPart}_${this.$route.params.idStudentTraining}`;
    },
    saveSurveyDataAuto(surveyData) {
      // Sauvegarder automatiquement les données du Survey en local
      // Cette sauvegarde est temporaire et sera remplacée par la sauvegarde finale
      try {
        const autoSaveKey = this.getSurveyAutoSaveKey();
        const autoSaveData = {
          surveyData,
          entry: JSON.stringify(surveyData),
          content: JSON.stringify(surveyData),
          timestamp: new Date().toISOString(),
        };
        localStorage.setItem(autoSaveKey, JSON.stringify(autoSaveData));
        console.log('Données du Survey sauvegardées automatiquement');
      } catch (error) {
        console.error('Erreur lors de la sauvegarde automatique:', error);
      }
    },
    handleFieldFocus() {
      // Quand un champ reçoit le focus, démarrer le timer d'inactivité
      if (this.survey && this.survey.data) {
        this.startIdleSaveTimer(this.survey.data);
      }
    },
    startIdleSaveTimer(surveyData) {
      // Réinitialiser le timer précédent
      if (this.surveyIdleSaveTimeout) {
        clearTimeout(this.surveyIdleSaveTimeout);
      }

      // Démarrer un nouveau timer de 5 secondes
      this.surveyIdleSaveTimeout = setTimeout(() => {
        // Vérifier que les données n'ont pas changé depuis
        const currentData = this.survey ? this.survey.data : null;
        if (currentData && JSON.stringify(currentData) === JSON.stringify(surveyData)) {
          // Les données sont identiques, l'utilisateur est resté sur le champ sans action
          console.log('Sauvegarde automatique après 5 secondes d\'inactivité sur le champ');
          this.saveSurveyDataAuto(surveyData);
          
          // Si on est en ligne, synchroniser aussi
          if (this.isOnline && !this.isSyncing) {
            this.autoSyncSurveyData(surveyData);
          }
        }
      }, 5000); // 5 secondes d'inactivité
    },
    async autoSyncSurveyData(surveyData) {
      // Synchroniser automatiquement les données en arrière-plan si on est en ligne
      // Cette méthode est appelée silencieusement sans bloquer l'interface utilisateur
      if (!this.isOnline || this.isSyncing) {
        return;
      }

      try {
        const entry = JSON.stringify(surveyData);
        
        // Si on a déjà un idPatch, faire un PATCH
        if (this.idPatch) {
          await this.$http.patch(`booklet_parts_entries/${this.idPatch}/`, {
            content: entry,
          });
          console.log('Données du Survey synchronisées automatiquement (PATCH)');
          
          // Nettoyer la sauvegarde automatique après synchronisation réussie
          const autoSaveKey = this.getSurveyAutoSaveKey();
          localStorage.removeItem(autoSaveKey);
        } else {
          // Sinon, créer une nouvelle entrée
          const response = await this.$http.post('booklet_parts_entries/', {
            simple_booklet_part: this.$route.params.idPart,
            student_training: this.$route.params.idStudentTraining,
            content: entry,
          });
          
          if (response.data && response.data.id) {
            this.idPatch = response.data.id;
            console.log('Données du Survey synchronisées automatiquement (POST), idPatch:', this.idPatch);
            
            // Nettoyer la sauvegarde automatique après synchronisation réussie
            const autoSaveKey = this.getSurveyAutoSaveKey();
            localStorage.removeItem(autoSaveKey);
          }
        }
      } catch (error) {
        // En cas d'erreur, laisser la sauvegarde locale et ne pas bloquer l'utilisateur
        console.warn('Erreur lors de la synchronisation automatique (non bloquante):', error);
        // Ne pas afficher d'erreur à l'utilisateur, les données sont sauvegardées localement
      }
    },
    saveSurveyToLocalQueue(surveyData) {
      try {
        const storageKey = this.getStorageKey();
        let queue = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const queueItem = {
          id: Date.now() + Math.random(),
          action: 'surveyComplete',
          data: {
            surveyData,
            entry: JSON.stringify(surveyData),
            content: JSON.stringify(surveyData),
          },
          timestamp: new Date().toISOString(),
        };
        queue.push(queueItem);
        localStorage.setItem(storageKey, JSON.stringify(queue));
        this.pendingSyncCount = queue.length;
        
        // Conserver aussi dans la sauvegarde automatique
        const autoSaveKey = this.getSurveyAutoSaveKey();
        const autoSaveData = {
          surveyData,
          entry: JSON.stringify(surveyData),
          content: JSON.stringify(surveyData),
          timestamp: new Date().toISOString(),
        };
        localStorage.setItem(autoSaveKey, JSON.stringify(autoSaveData));
        
        console.log('Survey sauvegardé localement:', queueItem);
      } catch (error) {
        console.error('Erreur lors de la sauvegarde locale:', error);
        this.$buefy.toast.open({
          message: 'Erreur lors de la sauvegarde locale',
          type: 'is-danger',
        });
      }
    },
    saveBookletPartToLocalQueue(isPost, statusValidation) {
      try {
        const storageKey = this.getStorageKey();
        let queue = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const queueItem = {
          id: Date.now() + Math.random(),
          action: isPost ? 'postBookletPart' : 'patchBookletPart',
          data: {
            idPart: this.$route.params.idPart,
            idStudentTraining: this.$route.params.idStudentTraining,
            idPatch: this.idPatch,
            entry: this.formWaypoint.entry,
            content: this.formWaypoint.content,
            statusValidation,
          },
          timestamp: new Date().toISOString(),
        };
        queue.push(queueItem);
        localStorage.setItem(storageKey, JSON.stringify(queue));
        this.pendingSyncCount = queue.length;
        console.log('Booklet part sauvegardé localement:', queueItem);
      } catch (error) {
        console.error('Erreur lors de la sauvegarde locale:', error);
        this.$buefy.toast.open({
          message: 'Erreur lors de la sauvegarde locale',
          type: 'is-danger',
        });
      }
    },
    loadSavedSurveyData() {
      // Charger les données sauvegardées localement si elles existent
      // Priorité : 1) sauvegarde automatique récente, 2) dernière complétion du survey
      
      if (!this.survey) {
        return;
      }

      const autoSaveKey = this.getSurveyAutoSaveKey();
      const autoSaveDataStr = localStorage.getItem(autoSaveKey);
      
      // Essayer d'abord la sauvegarde automatique (plus récente)
      if (autoSaveDataStr) {
        try {
          const autoSaveData = JSON.parse(autoSaveDataStr);
          if (autoSaveData.surveyData) {
            // Charger les données dans le survey
            Object.keys(autoSaveData.surveyData).forEach(key => {
              this.survey.setValue(key, autoSaveData.surveyData[key]);
            });
            // Incrémenter la version pour forcer le recalcul de isSurveyValid
            this.surveyDataVersion++;
            console.log('Données du survey restaurées depuis la sauvegarde automatique');
            
            // Afficher un message informatif
            this.$buefy.toast.open({
              message: 'Vos modifications précédentes ont été restaurées',
              type: 'is-info',
              duration: 3000,
            });
            return; // Ne pas charger depuis la queue si on a une sauvegarde auto
          }
        } catch (error) {
          console.error('Erreur lors du chargement de la sauvegarde automatique:', error);
        }
      }

      // Sinon, essayer de charger depuis la queue de synchronisation
      const storageKey = this.getStorageKey();
      const queue = JSON.parse(localStorage.getItem(storageKey) || '[]');
      
      if (queue.length > 0) {
        // Trouver la dernière sauvegarde de type surveyComplete
        const lastSurveySave = queue
          .filter(item => item.action === 'surveyComplete')
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[0];
        
        if (lastSurveySave) {
          // Charger les données dans le survey
          try {
            // Utiliser setValue pour chaque question du survey
            if (lastSurveySave.data.surveyData) {
              Object.keys(lastSurveySave.data.surveyData).forEach(key => {
                this.survey.setValue(key, lastSurveySave.data.surveyData[key]);
              });
              // Incrémenter la version pour forcer le recalcul de isSurveyValid
              this.surveyDataVersion++;
              console.log('Données du survey restaurées depuis la queue de synchronisation');
              
              // Afficher un message informatif
              this.$buefy.toast.open({
                message: 'Données sauvegardées localement restaurées',
                type: 'is-info',
                duration: 3000,
              });
            }
          } catch (error) {
            console.error('Erreur lors du chargement des données sauvegardées:', error);
          }
        }
      }
    },
    async syncQueue() {
      if (!this.isOnline || this.isSyncing) {
        return;
      }

      const storageKey = this.getStorageKey();
      let queue = JSON.parse(localStorage.getItem(storageKey) || '[]');

      if (queue.length === 0) {
        this.pendingSyncCount = 0;
        return;
      }

      this.isSyncing = true;
      this.lastSyncSuccess = false;

      const processedItems = [];

      // Traiter aussi les validations en attente
      const validationStorageKey = `booklet_validation_sync_queue_${this.$route.params.idPart}_${this.$route.params.idStudentTraining}`;
      let validationQueue = JSON.parse(localStorage.getItem(validationStorageKey) || '[]');
      
      // Traiter les items de la queue un par un
      for (const item of queue) {
        try {
          if (item.action === 'surveyComplete') {
            // Mettre à jour les données locales
            this.formWaypoint.entry = item.data.entry;
            this.formWaypoint.content = item.data.content;
            
            // Enregistrer via patchBookletPart ou postBookletPart
            let response;
            if (this.idPatch) {
              response = await this.$http.patch(`booklet_parts_entries/${this.idPatch}/`, {
                content: item.data.entry,
              });
            } else {
              response = await this.$http.post('booklet_parts_entries/', {
                simple_booklet_part: this.$route.params.idPart,
                student_training: this.$route.params.idStudentTraining,
                content: item.data.content,
              });
              // Si c'est une création, mettre à jour idPatch
              if (response.data && response.data.id) {
                this.idPatch = response.data.id;
              }
            }
            
            processedItems.push(item.id);
            console.log('Survey synchronisé avec succès:', item);
            
            // Nettoyer la sauvegarde automatique après synchronisation réussie
            const autoSaveKey = this.getSurveyAutoSaveKey();
            localStorage.removeItem(autoSaveKey);
          } else if (item.action === 'postBookletPart') {
            const response = await this.$http.post('booklet_parts_entries/', {
              simple_booklet_part: item.data.idPart,
              student_training: item.data.idStudentTraining,
              content: item.data.content,
            });
            
            // Si on a une validation, la traiter
            if (item.data.statusValidation) {
              await this.postValidation(item.data.statusValidation, response.data.id);
            }
            
            processedItems.push(item.id);
            console.log('Booklet part POST synchronisé avec succès:', item);
          } else if (item.action === 'patchBookletPart') {
            await this.$http.patch(`booklet_parts_entries/${item.data.idPatch}/`, {
              content: item.data.entry,
            });
            
            // Si on a une validation, la traiter
            if (item.data.statusValidation) {
              await this.postValidation(item.data.statusValidation);
            }
            
            processedItems.push(item.id);
            console.log('Booklet part PATCH synchronisé avec succès:', item);
          }
        } catch (error) {
          console.error('Erreur lors de la synchronisation:', error);
          // Si erreur serveur (5xx), garder l'item pour réessayer plus tard
          if (error.response && error.response.status >= 500) {
            console.log('Erreur serveur, conservation de l\'item dans la queue');
          }
        }
      }

      // Retirer les items synchronisés avec succès
      queue = queue.filter(item => !processedItems.includes(item.id));
      localStorage.setItem(storageKey, JSON.stringify(queue));
      this.pendingSyncCount = queue.length;

      this.isSyncing = false;

      if (processedItems.length > 0) {
        this.lastSyncSuccess = true;
        this.$buefy.toast.open({
          message: `${processedItems.length} ${processedItems.length > 1 ? 'modifications' : 'modification'} synchronisée${processedItems.length > 1 ? 's' : ''} avec succès`,
          type: 'is-success',
          duration: 4000,
        });

        // Masquer le message de succès après 5 secondes
        setTimeout(() => {
          this.lastSyncSuccess = false;
        }, 5000);

        // Recharger les données pour avoir les dernières versions
        this.initBookletPart();
      }

      // Synchroniser les validations en attente
      if (validationQueue.length > 0) {
        const processedValidations = [];
        for (const item of validationQueue) {
          try {
            if (item.action === 'postValidation') {
              await this.$http.post('/validations/validation/', item.data);
              processedValidations.push(item.id);
              console.log('Validation synchronisée avec succès:', item);
            }
          } catch (error) {
            console.error('Erreur lors de la synchronisation de la validation:', error);
            if (error.response && error.response.status >= 500) {
              console.log('Erreur serveur, conservation de la validation dans la queue');
            }
          }
        }

        // Retirer les validations synchronisées
        validationQueue = validationQueue.filter(item => !processedValidations.includes(item.id));
        localStorage.setItem(validationStorageKey, JSON.stringify(validationQueue));

        if (processedValidations.length > 0) {
          this.loadPendingSyncCount(); // Mettre à jour le compteur
          this.$buefy.toast.open({
            message: `${processedValidations.length} ${processedValidations.length > 1 ? 'validations' : 'validation'} synchronisée${processedValidations.length > 1 ? 's' : ''} avec succès`,
            type: 'is-success',
            duration: 4000,
          });
        }
      }
      
      // Mettre à jour le compteur final
      this.loadPendingSyncCount();
    },
    handleOnline() {
      this.isOnline = true;
      console.log('Connexion rétablie, synchronisation en cours...');
      this.syncQueue();
    },
    handleOffline() {
      this.isOnline = false;
      console.log('Connexion perdue, passage en mode hors ligne');
      this.$buefy.toast.open({
        message: 'Vous êtes maintenant hors ligne. Vos modifications seront sauvegardées localement.',
        type: 'is-warning',
        duration: 4000,
      });
    },
    loadPendingSyncCount() {
      const storageKey = this.getStorageKey();
      const queue = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const validationStorageKey = `booklet_validation_sync_queue_${this.$route.params.idPart}_${this.$route.params.idStudentTraining}`;
      const validationQueue = JSON.parse(localStorage.getItem(validationStorageKey) || '[]');
      this.pendingSyncCount = queue.length + validationQueue.length;
    },
    isValidationAllowed(validationItem) {
      // Les coordinateurs et directeurs peuvent toujours valider
      if (this.currentUser.role === 'coordinateur' || this.isDirector) {
        return true;
      }

      if (!this.booklet_validation.data || !this.booklet_validation.data[0].data[0].validations) {
        return true;
      }

      const validations = this.booklet_validation.data[0].data[0].validations;
      const currentPosition = validationItem.position;

      // Vérifier toutes les validations avec une position inférieure
      for (const validation of validations) {
        // Si la validation est avant la validation courante et qu'elle est bloquante
        if (validation.position < currentPosition && validation.blocking === true) {
          // Si cette validation bloquante n'est pas validée, bloquer la validation courante
          if (validation.status_label !== 'Valide') {
            return false;
          }
        }
      }

      return true;
    },
  },
  created() {
    this.startLoading();
    this.initBookletPart();
    this.initPart();
  },
  mounted() {
    // Écouter les changements de statut de connexion
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
    // Charger le nombre de synchronisations en attente
    this.loadPendingSyncCount();
    // Vérifier périodiquement si on peut synchroniser
    this.syncCheckInterval = setInterval(() => {
      if (navigator.onLine && !this.isOnline) {
        this.handleOnline();
      } else if (!navigator.onLine && this.isOnline) {
        this.handleOffline();
      }
    }, 5000);
    // Synchroniser immédiatement si en ligne et qu'il y a des items en attente
    if (this.isOnline && this.pendingSyncCount > 0) {
      this.syncQueue();
    }
  },
  destroyed() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
    if (this.syncCheckInterval) {
      clearInterval(this.syncCheckInterval);
    }
    if (this.surveySaveTimeout) {
      clearTimeout(this.surveySaveTimeout);
    }
    if (this.surveyIdleSaveTimeout) {
      clearTimeout(this.surveyIdleSaveTimeout);
    }
  },
});
</script>

<style lang="scss" scoped>
.card_buttons {
  margin-left: auto !important;
  min-width: 198px;
}

.titles {
  max-width: 460px;
  padding-right: 1rem;
}

.studentName {
  font-weight: bold;
  font-size: 1.4rem;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .card_activity::after {
    content: unset;
    color: #c1bbd0cc;
  }

  .card_activity {
    border-bottom: 1px solid #ededed;
  }

  .card_activity:last-child {
    border-bottom: 0px solid #ededed;

    &::after {
      content: unset;
    }
  }
}

@media screen and (max-width: 576px) {
  .content-steps {
    flex-direction: column;
  }

  .card_buttons {
    margin-left: 0px !important;
    padding-top: 0.5rem;
  }

  .titles {
    flex-direction: column;
  }
}

.sd-btn--action.sd-navigation__complete-btn {
  display: none !important;
}

.sd-body__navigation .sd-btn,
.sd-navigation__prev-btn,
.sd-navigation__next-btn {
  border-radius: 9999px !important;
  padding-left: calc(1em + 0.25em) !important;
  padding-right: calc(1em + 0.25em) !important;
}
</style>
